"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _angular = _interopRequireDefault(require("angular"));

var _jquery = _interopRequireDefault(require("jquery"));

require("bootstrap/js/dist/alert");

require("bootstrap/js/dist/modal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modal = "<aside class=\"modal fade\" id=\"modalAlert\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\r\n\t<div class=\"modal-dialog\" role=\"document\">\r\n\t\t<div class=\"modal-content border-0\">\r\n\t\t\t<div class=\"alert mb-0\" role=\"alert\" ng-class=\"documentAlertStyle ? ('alert-' + documentAlertStyle) : ''\">\r\n\t\t\t\t<h2 class=\"alert-heading\">{{documentAlertTitle}}</h2>\r\n\r\n\t\t\t\t<p>{{documentAlertBody}}</p>\r\n\r\n\t\t\t\t<div class=\"d-flex justify-content-end\">\r\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-sm ml-2\" ng-repeat=\"button in documentAlertButtons\" ng-click=\"button.fn()\" ng-class=\"button.style ? ('btn-' + button.style) : ('btn-outline-' + documentAlertStyle)\">\r\n\t\t\t\t\t\t{{button.label}}\r\n\t\t\t\t\t</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</aside>";
var alert = "<aside class=\"notifications blocked\">\r\n\t<h2 class=\"sr-only\">Notifica\xE7\xF5es</h2>\r\n\r\n\t<div class=\"notifications-item animate\" ng-repeat=\"notification in notifications | reverse\" ng-if=\"notification.active\">\r\n\t\t<div class=\"alert alert-dismissible\" role=\"alert\" ng-class=\"'alert-' + notification.type\">\r\n\t\t\t<i class=\"material-icons material-icons-24 mr-2\">&#xE88F;</i>\r\n\r\n\t\t\t<div class=\"d-inline\" ng-inner-html=\"notification.body\"></div>\r\n\r\n\t\t\t<button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"notification.active = false\">\r\n\t\t\t\t<span aria-hidden=\"true\">&times;</span>\r\n\t\t\t</button>\r\n\t\t</div>\r\n\t</div>\r\n</aside>";

(function (angular, $) {
  $('body').append(modal).append(alert);
  angular.module('genese.notification', []).service('notification', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
    var _this = this;

    this.push = function (_ref) {
      var _ref$body = _ref.body,
          body = _ref$body === void 0 ? '' : _ref$body,
          _ref$type = _ref.type,
          type = _ref$type === void 0 ? 'info' : _ref$type,
          _ref$duration = _ref.duration,
          duration = _ref$duration === void 0 ? 5000 : _ref$duration;
      if (typeof $rootScope.notifications === 'undefined') $rootScope.notifications = [];
      var notification = {
        active: true,
        over: false,
        body: body,
        type: type,
        duration: duration
      };
      $rootScope.notifications.push(notification);

      if (!$rootScope.$$phase) {
        $rootScope.$apply();
      }
      $timeout(function () {
        return notification.active = false;
      }, duration);
    };
    /** Atalhos */


    this.info = function (body) {
      return _this.push({
        body: body,
        type: 'info'
      });
    };

    this.success = function (body) {
      return _this.push({
        body: body,
        type: 'success'
      });
    };

    this.warning = function (body) {
      return _this.push({
        body: body,
        type: 'warning'
      });
    };

    this.danger = function (body) {
      return _this.push({
        body: body,
        type: 'danger'
      });
    };
    /** Alertas */


    this.alert = function (_ref2) {
      var _ref2$title = _ref2.title,
          title = _ref2$title === void 0 ? 'Alerta' : _ref2$title,
          _ref2$body = _ref2.body,
          body = _ref2$body === void 0 ? '' : _ref2$body,
          _ref2$buttons = _ref2.buttons,
          buttons = _ref2$buttons === void 0 ? [] : _ref2$buttons,
          _ref2$style = _ref2.style,
          style = _ref2$style === void 0 ? 'alert-info' : _ref2$style;

      $timeout(function(){
        $rootScope.documentAlertStyle = style;
        $rootScope.documentAlertTitle = title;
        $rootScope.documentAlertBody = body;
        $rootScope.documentAlertButtons = buttons;
      });

      $('#modalAlert').modal('show');
    };

    this.close = function () {
      return $('#modalAlert').modal('hide');
    };
  }]);

  setTimeout(function() {
    $('aside.notifications').removeClass('blocked');
  }, 2000);

})(_angular.default, _jquery.default);

var _default = 'genese.notification';
exports.default = _default;